<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Wasteless</span>
    </div>

    <div style="display:inline-flex;">
      <div @click="downloadBalanceSheetModel()" style="cursor:pointer;margin:9px 6px;"><img src="/img/icons/white/download.png"> Baixar Planilha de Produtos</div>
      <div style="margin:9px 6px;" ><label for="selecao-arquivo-create"> <img src="/img/icons/white/download.png" style="transform: rotate(180deg);"/> Criar Produtos Wasteless via Planilha</label>
        <input id="selecao-arquivo-create" @change="uploadBalanceSheet($event)" type="file"/></div>
    </div>

    <div class="line">
      <div class="col6">
        <div class="lineBox" style="padding-top:10px;border:0px;">
          <span class="h3" style="float:left;margin-top:5px;">Adicionar lista </span>
          <button @click="openModalList()" style="float:right;width:186px;">Novo Código</button>
        </div>
        <div class="lineBox" style="margin-top:10px; min-height: 75px; min-width:600px;">
          <div style="padding:10px; ">
            <table class="table" cellpadding="0" cellspacing="0" style="min-width:600px">
              <thead>
              <tr>
                <td style="text-align:left;">Códigos</td>
                <td style="text-align:left;">Dias restantes</td>
                <td style="text-align:left;">Desconto (%)</td>
                <td style="text-align:center;width:40px">Remover</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(offer, idx ) in wastelessList" v-bind:key="idx">
                <td style="text-align:left;">{{offer.code}}</td>
                <td>
                  <table>
                    <tr v-for="(discountItem, idxd ) in offer.discount_list" v-bind:key="idxd">
                      <td >{{discountItem.days_left}} dias</td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table>
                    <tr v-for="(discountItem, idxdd ) in offer.discount_list" v-bind:key="idxdd">
                      <td style="text-align:left;" >{{discountItem.discount}}%</td>
                    </tr>
                  </table>
                </td>
                <td style="text-align:center;">
                  <div style="display:inline-flex;">
                    <div @click="removeWastelessList(offer)">
                      <OpaIcon name="remove" alt="Excluir" color="red" style="cursor:pointer;margin:6px;"/>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <OpaModal v-if="currentCode" v-model="showModalList" width="800" height="630" header="Novo Código">
      <div style="height:450px;overflow:auto; padding:20px;">
        <input oninput="this.value = this.value.toUpperCase()" type="text" class="inputText inputTag" placeholder="Código" v-model="currentCode.code"/>
        <br/><br/>
        <br/>
        <div class="line">
          <div class="inputLabel">Condições</div>
          <button @click="plusWastelessConditionCode(currentCode)"> + condição</button>
          <table style="border:1px; border-collapse:collapse;width:100%;" border="1" cellpadding="5">
            <tr>
              <td style="text-align:left;">Dias restantes</td>
              <td style="text-align:left;">Desconto (%)</td>
              <td style="text-align:center;width:40px">Remover</td>
            </tr>
            <tr v-for="(offer, idx ) in currentCode.discount_list" v-bind:key="idx">
              <td>
                <input type="number" v-model.number="offer.days_left" style="width:100%;height:30px;"/>
              </td>
              <td>
                <input type="number" v-model.number="offer.discount" style="width:100%;height:30px"/>
              </td>
              <td>
                <button @click="removeWastelessCode(currentCode.discount_list, idx)">Remover</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveWastelessList(currentCode)">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="closeModalList()">Cancelar</button>
      </div>
    </OpaModal>

  </div>
</template>

<script>

  import OpaIcon from '@/components/OpaIcon.vue'
  import OpaModal from '@/components/OpaModal.vue'
  import {EventBus} from '@/utils/event-bus'
  import {mapGetters} from 'vuex'
  import WastelessConn from '@/connection/Wasteless'
  import axios from 'axios'

  export default {
    name: 'Wasteless',
    data() {
      return {
        wastelessList: [],
        showModalList: false,
        currentCode: {
          code: null,
          discount_list: [{
            discount: null,
            days_left: null
          }]
        }
      }
    },

    components: {OpaIcon, OpaModal},

    async created() {
      await this.refreshLists()
    },

    methods: {

      ...mapGetters(['getAdmin', 'getCompany', 'getProductApi']),

      plusWastelessConditionCode(currentCode) {
        if (!currentCode.discount_list) {
          currentCode.discount_list = []
        }
        currentCode.discount_list.push({
          'discount': null,
          'days_left': null
        })
        this.$forceUpdate()
      },

      removeWastelessCode(discountList, idx) {
        this.currentCode.discount_list.splice(idx, 1)
        this.$forceUpdate()
      },

      async refreshLists() {
        EventBus.$emit('showLoading', true)
        let result = await WastelessConn.getWastelessList()
        if (result.error) {
          alert('Erro:' + result.data)
        } else {
          this.wastelessList = result
          EventBus.$emit('showLoading', false)
        }
      },

      async saveWastelessList(currentCode) {
        if (!currentCode.code) {
          EventBus.$emit('showAlert', 'error', 'Por favor, preencha o campo código')
          return
        }
        if (!currentCode.discount_list[0].days_left) {
          EventBus.$emit('showAlert', 'error', 'Por favor, preencha ao menos uma condição de dia')
          return
        }
        if (!currentCode.discount_list[0].discount) {
          EventBus.$emit('showAlert', 'error', 'Por favor, preencha ao menos uma condição de desconto')
          return
        }
        EventBus.$emit('showLoading', true)
        let result = await WastelessConn.saveNewWasteless(currentCode)
        if (result && !result.error) {
          this.closeModalList()
          await this.refreshLists()
          EventBus.$emit('showAlert', 'success', 'Código criado com sucesso')
        } else {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      },

      async removeWastelessList(offer) {
        this.currentCode = offer
        EventBus.$emit('showLoading', true)
        if (confirm('Deseja realmente remover o código "' + offer.code + '"?')) {
          let result = await WastelessConn.deleteOfferList(offer)
          if (!result.error) {
            await this.refreshLists()
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'Código removido com sucesso')
          } else {
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'Erro ao remover código')
          }
        } else {
          EventBus.$emit('showLoading', false)
        }
      },

      uploadBalanceSheet(e) {
        if (e.target.value) {
          let bodyFormData = new FormData()
          bodyFormData.append('file', e.target.files[0])
          EventBus.$emit('showLoading', true)
          axios({
            method: 'post',
            url: this.getProductApi() + '/wasteless/xlsx/products',
            data: bodyFormData,
            config: {headers: {'Content-Type': 'form-data'}}
          })
                  .then(function (response) {
                    if (response.data) {
                      EventBus.$emit('showLoading', false)
                      EventBus.$emit('showAlert', 'success', 'Produtos Wasteless atualizados')
                    }
                  })
                  .catch((err) => {
                    if (err.msg) {
                      EventBus.$emit('showAlert', 'error', err.msg)
                    } else {
                      console.log(err)
                      EventBus.$emit('showAlert', 'error', 'Erro ao criar produtos wasteless')
                    }
                    EventBus.$emit('showLoading', false)
                  })
        }
      },

      downloadBalanceSheetModel () {
        window.open('https://cdnopa4.s3.amazonaws.com/products/wasteless.xlsx', '_blank')
      },

      openModalList() {
        this.currentCode = {
          code: null,
          discount_list: [{
            discount: null,
            days_left: null
          }]
        }
        this.showModalList = true
      },

      closeModalList() {
        this.showModalList = false
        this.currentCode = {
          code: null,
          discount_list: [{
            discount: null,
            days_left: null
          }]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .imgBgWhite {
    background-color: #ffffff;
  }

  input[type='file'] {
    display: none;
  }

  label {
    float: left;
    width: 320px;
    height: 40px;
    background-color: #12FCC4;
    border: 0px;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    color: #423D4E;
    font-family: Roboto;
    font-size: 14px;
    line-height: 40px;
    vertical-align: middle;
    text-align: center;
    font-weight: 500;
    text-decoration: none;
  }
</style>
